import { SKU } from "@/entities/pricing/model/priceBook";
import { useQuotePreview } from "@/entities/pricing/model/useQuote";

import { formatPerSecondRate, useDhPerSecondRate } from "../../model/useDhPerSecondRate";

/**
 * 照片线单价卡(I3;B2 #16 起各自问价)。1019 照片省流版永久下架前这里是「生动版 / 省流版」两档对照的
 * 一格(可点选),下架后照片档只剩生动版,收成一张只读的单价卡。
 *
 * ★单价读目录的不取整列(`creditsPerUnitExact`,0927 K4 I 起与 hub 卡面同一列),「这稿预计」问后端报价口
 *   (dryRun),都不再用目录整数 × 秒(目录取整字段对不足 1 分的线是上界,会高报)。
 * ★取不到 → 单价显「—」、预估不出数(不兜整数上界,一个说得斩钉截铁却不准的数比不显示更糟)。
 */
export function DhPhotoRateCard({
  name,
  hint,
  variantKey,
  seconds,
}: {
  name: string;
  hint: string;
  /** 该档的价目表规格档 key(api price-variants 给);null = 表没到货。 */
  variantKey: string | null;
  /** 当前文案估算秒数;0 = 还没写文案,不出「这稿预计」。 */
  seconds: number;
}) {
  const rate = useDhPerSecondRate(variantKey);
  const { credits } = useQuotePreview(
    seconds > 0 && variantKey ? { skuCode: SKU.dhRender, variantKey, qty: seconds } : null
  );
  return (
    <div className="rounded-md border p-2 text-left">
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-xs font-medium">{name}</span>
        <span className="text-2xs tabular-nums text-muted-foreground">
          {rate == null ? "—" : `${formatPerSecondRate(rate)} 积分/秒`}
        </span>
      </div>
      <div className="mt-0.5 text-2xs text-muted-foreground">{hint}</div>
      {/* ★下面这行是**用户要读的价钱**,用正文色不用 text-primary:
          comic 的 --primary 是浅粉,压白卡实测 2.41(要 4.5),standard 也只有 2.9 ——
          存量教训写着「口径不一致比不显示更糟」,看不清同理。强调靠字重,不靠颜色。 */}
      {seconds > 0 && credits != null && (
        <div className="mt-1 text-2xs font-medium tabular-nums text-foreground">
          这稿预计 ≈ {credits.toLocaleString()} 积分
        </div>
      )}
    </div>
  );
}
